/**
 * Cal.com — agendamento de demonstração comercial WSJ (landing / CTAs).
 * Opcional: VITE_WSJ_CAL_DEMO_URL no build.
 */
export const WSJ_CAL_DEMO_BOOKING_URL =
  'https://cal.com/william-sarti-w1lhuh/agendar-demonstracao';

export function getWsjCalDemoBookingUrl() {
  const fromEnv = String(process.env.VITE_WSJ_CAL_DEMO_URL || '').trim();
  if (fromEnv) return fromEnv;
  return WSJ_CAL_DEMO_BOOKING_URL;
}
